import "./Industries.module.css";
import Header from "@/reusable_sections/Header";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import IndustryRoutingGrid from "./sections/IndustryRoutingGrid";
import MapProductsServicesToIndustry from "./sections/MapProductsServicesToIndustry";
import ByBuyerType from "./sections/ByBuyerType";
import WhyEvermarkAcrossIndustries from "./sections/WhyEvermarkAcrossIndustries";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <Header />
      <DirectAnswerBlock />
      <IndustryRoutingGrid />
      <MapProductsServicesToIndustry />
      <ByBuyerType />
      <WhyEvermarkAcrossIndustries />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}